import React, { useEffect, useState } from "react";
import Sidebar from "../../CoustamComponent/Sidebar";
import LoaderHelper from "../../../Services/Loading/LoaderHelper";
import { alertErrorMessage, alertSuccessMessage } from "../../../Services/CustomAlertModel";
import AuthService from "../../../Services/ApiServices/AuthService";
import { useNavigate } from "react-router-dom";

const ForgotPinNumber = () => {

    const [formData, setFormData] = useState({ otp: "", pinNumber: "", confirmPinNumber: "" });
    const [showPass, setshowPass] = useState(false);
    const [showPass2, setshowPass2] = useState(false);
    const [countdown, setCountdown] = useState(0);
    const [isOtpSent, setIsOtpSent] = useState(false);
    const navigate = useNavigate();
    const emailId = sessionStorage.getItem('emailId');


    const handleInputChange = (event) => {
        const { name, value } = event.target;
        if (name === 'pinNumber' || name === 'confirmPinNumber') {
            if (value.length <= 4) {
                setFormData({ ...formData, [name]: value });
            } else {
                alertErrorMessage("Pin cannot exceed 4 digits");
            }
        } else if (name === 'otp') {
            if (value.length <= 6) {
                setFormData({ ...formData, [name]: value });
            } else {
                alertErrorMessage("OTP cannot exceed 6 digits");
            }
        }
        else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleGetOtp = async (type) => {
        LoaderHelper.loaderStatus(true);
        try {
            const result = await AuthService.create_pin(type, emailId);
            LoaderHelper.loaderStatus(false);
            if (result?.success) {
                alertSuccessMessage(result?.message);
                setIsOtpSent(true);
                setCountdown(60);
            } else {
                alertErrorMessage(result?.message);
                setIsOtpSent(false);
                setCountdown(0);
                console.log("🚀 ~ handleGetOtp ~ result?.message:", result)
            };

        } catch (error) {
            LoaderHelper.loaderStatus(false);
            alertErrorMessage(error);
        }
    };


    const handleChangePinNumber = async (otp, pinNumber, confirmPinNumber) => {
        if (!otp || !pinNumber || !confirmPinNumber) {
            alertErrorMessage('All Fields are required.');
            return;
        } else if (pinNumber.length !== 4 || confirmPinNumber.length !== 4) {

        } else if (pinNumber !== confirmPinNumber) {
            alertErrorMessage('Pin Number and Confirm Pin Number should be same.');
            return;
        }
        LoaderHelper.loaderStatus(true);
        try {
            const result = await AuthService.changePinNumber(otp, pinNumber, confirmPinNumber);
            LoaderHelper.loaderStatus(false);
            if (result?.success) {
                alertSuccessMessage(result?.message);
                navigate("/withdraw");
            } else {
                alertErrorMessage(result);
            };
        } catch (error) {
            alertErrorMessage(error);
        }
    };


    useEffect(() => {
        let timer;
        if (isOtpSent && countdown > 0) {
            timer = setInterval(() => {
                setCountdown((prevCountdown) => prevCountdown - 1);
            }, 1000);
        } else if (countdown === 0) {
            setIsOtpSent(false);
        }
        return () => clearInterval(timer);
    }, [isOtpSent, countdown]);

    return (
        <div class="wrapper dashboard_page ">
            <div class=" page-body d-flex align-items-stretch">
                <div class="page-content">
                    <Sidebar />
                    <div className="page_wrapper" >
                        <div className="container container-custom" >
                            <form class="custom-form ticket-form mb-5 mb-lg-0 ">
                                <div className="login_form" >
                                    <div class=" d-block text-center mb-5">
                                        <h2 class="mb-1">  <strong class=" "> Change PIN Number? </strong> </h2>
                                        <p> Enter details to Change your PIN Number.</p>
                                    </div>
                                    <div className="cfield_group login_group " >
                                        <label class="mb-2"> Verification Code  </label>
                                        <div class="cfield mb-3">
                                            <div class=" field-otp-box">
                                                <input type="text" class="form-control" placeholder="Enter Code" name="otp" value={formData.otp}
                                                    onChange={(e) => (/^\d*$/.test(e.target.value) && handleInputChange(e))} onPaste={(e) => e.preventDefault()} />
                                                <button class="btn btn-sm btn-gradient" type="button" onClick={() => handleGetOtp('otp_pin')} disabled={isOtpSent}>
                                                    <span>{isOtpSent ? `Resend in ${countdown}s` : 'GET OTP'}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class=" cfield_group login_group">
                                        <label class="mb-2">  New PIN Number </label>
                                        <div class="cfield mb-3 ">
                                            <div class=" field-otp-box">
                                                <input type='text' class="form-control" name="pinNumber" placeholder="Enter New PIN Number" value={formData.pinNumber}
                                                    onChange={(e) => (/^\d*$/.test(e.target.value) && handleInputChange(e))} onPaste={(e) => e.preventDefault()} />
                                                {/* <button type="button" class="btn btn-icon btn_view_pass btn-white" onClick={() => { setshowPass(!showPass) }}>
                                                    <i className={`ri-eye${showPass ? "-line" : "-off-line"}`} />
                                                </button> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div class=" cfield_group login_group">
                                        <label class="mb-2">  Confirm New PIN Number </label>
                                        <div class="cfield mb-3 ">
                                            <div class=" field-otp-box">
                                                <input type='text' class="form-control" name="confirmPinNumber" placeholder="Enter Confirm New PIN Number" value={formData.confirmPinNumber}
                                                    onChange={(e) => (/^\d*$/.test(e.target.value) && handleInputChange(e))} onPaste={(e) => e.preventDefault()} />
                                                {/* <button type="button" class="btn btn-icon btn_view_pass btn-white" onClick={() => { setshowPass2(!showPass2) }}>
                                                    <i className={`ri-eye${showPass2 ? "-line" : "-off-line"}`} />
                                                </button> */}
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" class="btn custom-btn btn-gradient btn-border w-100 mt-3" onClick={() => handleChangePinNumber(formData.otp, formData.pinNumber, formData.confirmPinNumber)}><span> SUBMIT</span></button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForgotPinNumber


